import { Numeric6BoxOutlineIcon } from './Numeric6BoxOutlineIcon';

/**
 * author: Google
 * id 8ED3719B-D733-46ED-BFCF-0BDE0819F7EF
 * name numeric-6-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-6-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number6BoxOutlineIcon = Numeric6BoxOutlineIcon;
export default Number6BoxOutlineIcon